import { render } from "./AfterStoryDetails.vue?vue&type=template&id=4f825aaa&scoped=true"
import script from "./AfterStoryDetails.vue?vue&type=script&lang=js"
export * from "./AfterStoryDetails.vue?vue&type=script&lang=js"

import "./AfterStoryDetails.vue?vue&type=style&index=0&id=4f825aaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f825aaa"]])

export default __exports__